var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertAwardStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 37.5834L27.7768 30.173C27.6043 29.6779 27.2872 29.2459 26.8666 28.9328C26.446 28.6197 25.9411 28.4399 25.4173 28.4167H19.9173C19.3935 28.4399 18.8887 28.6197 18.468 28.9328C18.0474 29.2459 17.7304 29.6779 17.5578 30.173L15.334 37.5834",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.668 28.413V22.9185",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9618 1.70681L26.7833 8.24997H32.2741C32.5511 8.23989 32.8246 8.31551 33.0571 8.46652C33.2896 8.61753 33.4698 8.83657 33.5733 9.09378C33.6767 9.35099 33.6983 9.63385 33.6351 9.90379C33.5719 10.1737 33.427 10.4176 33.2201 10.6021L28.4571 14.85L31.0971 20.9238C31.213 21.2016 31.2388 21.5088 31.171 21.802C31.1032 22.0953 30.9451 22.3599 30.719 22.5586C30.493 22.7574 30.2103 22.8802 29.9108 22.9099C29.6112 22.9396 29.3099 22.8746 29.0493 22.7241L22.6674 19.129L16.2874 22.7333C16.0259 22.8878 15.7222 22.9556 15.4198 22.927C15.1174 22.8984 14.8318 22.7748 14.6039 22.574C14.376 22.3731 14.2175 22.1053 14.1511 21.8089C14.0846 21.5125 14.1137 21.2027 14.2341 20.9238L16.8796 14.85L12.1129 10.6058C11.9048 10.4217 11.7586 10.1777 11.6945 9.90724C11.6304 9.63681 11.6515 9.35318 11.7549 9.09521C11.8583 8.83723 12.0389 8.61754 12.2721 8.46622C12.5052 8.31491 12.7794 8.23937 13.0571 8.24997H18.5571L21.3731 1.70681C21.4982 1.47215 21.6847 1.2759 21.9126 1.13906C22.1406 1.00222 22.4015 0.929932 22.6674 0.929932C22.9333 0.929932 23.1942 1.00222 23.4222 1.13906C23.6502 1.2759 23.8367 1.47215 23.9618 1.70681Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.668 40.3333C33.668 41.0627 33.3782 41.7621 32.8625 42.2779C32.3468 42.7936 31.6473 43.0833 30.918 43.0833H14.418C13.6886 43.0833 12.9891 42.7936 12.4734 42.2779C11.9577 41.7621 11.668 41.0627 11.668 40.3333C11.668 39.604 11.9577 38.9045 12.4734 38.3888C12.9891 37.873 13.6886 37.5833 14.418 37.5833H30.918C31.6473 37.5833 32.3468 37.873 32.8625 38.3888C33.3782 38.9045 33.668 39.604 33.668 40.3333Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertAwardStar);
export default __webpack_public_path__ + "static/media/expert_award_star.36517be610f9daf26774bb87418ea6fc.svg";
export { ForwardRef as ReactComponent };